// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"_18v1tjHOyshf","title":"_2-k6Rp5TP_l0","buttons":"_3NJ7-IKvEl8V","step":"neU08_8UUIBC","prevButton":"_1npr0dTEzsPL"};